import { render, staticRenderFns } from "./happytogether.vue?vue&type=template&id=bc46a5ea&scoped=true&"
import script from "./happytogether.vue?vue&type=script&lang=js&"
export * from "./happytogether.vue?vue&type=script&lang=js&"
import style0 from "./happytogether.vue?vue&type=style&index=0&id=bc46a5ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc46a5ea",
  null
  
)

/* custom blocks */
import block0 from "./happytogether.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports